/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embedding_Priority_HintInputs */



/**
* | output |
* | --- |
* | "Decides which of your spaces is embedded first when several are waiting. Only affects your organisation." |
*
* @param {Spaces_Embedding_Priority_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_priority_hint = /** @type {((inputs?: Spaces_Embedding_Priority_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Priority_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legt fest, welcher Ihrer Spaces zuerst eingebettet wird, wenn mehrere warten. Wirkt nur innerhalb Ihrer Organisation.")
	return /** @type {LocalizedString} */ ("Decides which of your spaces is embedded first when several are waiting. Only affects your organisation.")
});